module.exports = __webpack_public_path__ + "static/media/mira_launch_3.4f6f9fa4.jpeg";